export class Accesstokenjwt{
    isbackoffice:Boolean;
    partnerid:string;
    userid:string;
}